import { useContext, useState }                                  from "react";
import { WifiOff, Clock, X }                                     from "lucide-react";
import Context                                                   from "@/provider/Context";

/* Avisos fixos no rodape da tela:
   - a API nao respondeu e o site esta com os dados de exemplo;
   - o RPG ainda nao foi lancado (catalogo.lancado = false). */
export default function AvisoRpg() {
  const { Catalogo, UsandoExemplo }   = useContext(Context);
  const [fechado, set_fechado]        = useState(false);

  const avisos = [];
  if (UsandoExemplo) {
    avisos.push({ icone: WifiOff, texto: "Não conseguimos falar com o servidor agora. Você está vendo dados de exemplo." });
  }
  if (Catalogo && Catalogo.lancado === false) {
    avisos.push({ icone: Clock, texto: "Em breve: o nível do RPG passa a valer no lançamento. Até lá, os números podem mudar." });
  }

  if (fechado || !avisos.length) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-xl">
      <div className="void-card void-glow p-3 pr-10 relative space-y-2">
        {avisos.map(({ icone: Icone, texto }) => (
          <div key={texto} className="flex items-start gap-3 text-sm font-rajdhani">
            <Icone className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
            <p className="text-foreground">{texto}</p>
          </div>
        ))}
        <button
          type="button"
          onClick={() => set_fechado(true)}
          className="absolute top-2 right-2 p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
          aria-label="Fechar aviso"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
